import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AdminService } from '../../../admin.service';
import { AdminActionsDirective } from '../../../directives/admin-actions.directive';
import { TranslateService } from '@ngx-translate/core';
import { IFaq } from '@shared/interfaces';
import { DialogService } from '../../../../../shared/services/dialog.service';
import { FaqService } from '../../../../../shared/services/faq.service';
import { SnackService } from '../../../../../shared/services/snack.service';
import { ModuleService } from '../../../../../shared/services/module.service';
import { IS_TRS_PROJECT } from '../../../../../../current-project';

@Injectable({ providedIn: 'root' })
export class FaqOperations extends AdminActionsDirective {
    formGroup: UntypedFormGroup;
    IS_TRS_PROJECT = IS_TRS_PROJECT;

    constructor(
        private snack: SnackService,
        private translate: TranslateService,
        private faqService: FaqService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    documentsToUpload(key: string): File[] {
        return this.formGroup.get(key).value;
    }

    async save(
        event: any,
        actionFunction: (value: IFaq, faqService: FaqService, snackService: SnackService) => Promise<void>,
        value: IFaq
    ): Promise<void> {
        const submitter: HTMLButtonElement = event.submitter;
        if (submitter) {
            submitter.disabled = true;
        }
        this.formGroup.markAllAsTouched();

        if (this.formGroup.valid) {
            try {
                if (IS_TRS_PROJECT) {
                    if (this.documentsToUpload('documents')?.length) {
                        await this.faqService.handleDocuments(value);
                    }
                } else {
                    console.log(this.documentsToUpload('documentsDE'));
                    if (this.documentsToUpload('documentsDE')?.length) {
                        value.documentsDE = await this.faqService.handleDocument(value.id, value.documentsDE, 'de');
                    }

                    if (this.documentsToUpload('documentsEN')?.length) {
                        value.documentsEN = await this.faqService.handleDocument(value.id, value.documentsEN, 'en');
                    }
                }

                await actionFunction(value, this.faqService, this.snack);
                console.log(value);
                this.goBackInFaq(null);
            } catch (e) {
                console.error(e);
            }
        } else {
            this.snack.openSnackBarError(this.translate.instant('project.register.requiredFields'));
        }
        if (submitter) {
            submitter.disabled = false;
        }
    }
}
